import 'Plugins/responsiveHelper';
import 'Plugins/accordionPlugin';
import 'Plugins/inViewportPlugin';

// accordion menu init

export default function initAccordion() {
  ResponsiveHelper.addRange({
    '..1023': {
      on: function() {
        jQuery('.accordion-mobile').slideAccordion({
          opener: '.opener',
          slider: '.slide',
          animSpeed: 300,
          collapsible: false,
          scrollToActiveItem: {
            enable: true,
            extraOffset: 0
          },
          onShow: function($item) {
             function initInViewport() {
  jQuery('.viewport-section').itemInViewport({});
}
          }
        });
      },
      off: function() {
        jQuery('.accordion-mobile').slideAccordion('destroy');
      }
    }
  });

  jQuery('.accordion').slideAccordion({
    opener: '.opener',
    slider: '.slide',
    animSpeed: 300,
    collapsible: false,
    scrollToActiveItem: {
      enable: true,
      extraOffset: 0
    }
  });
}